import React from 'react';
import { TicketView } from './TicketView';

export function TicketList() {
  return <TicketView />;
}

export default TicketList;
